import { Order } from "@/data/interfaces/OrderInterface";
import { ParamsData } from "@/data/interfaces/ParamsDataInterface";
import api from "./config";

export default {
  orders: async (params: object) => {
    const { data } = await api.get("/api/orders", {
      params: params,
    });
    return data;
  },
  createOrder: async (params: object) => {
    const { data } = await api.get("/api/orders", {
      params: params,
    });

    return data;
  },
  edit: async (order: Order, params: ParamsData) => {
    params["version"] = order.version;

    const { data } = await api.patch(
      `/api/orders/${order.orderId}/${order.orderPosition}/${order.directionType}`,
      params
    );
    return data;
  },

  delete: async (order: Order) => {
    // THIS IS ONLY FOR OUR TESTING PURPOSES
    const { data } = await api.post(
      `/api/orders/${order.orderId}/${order.orderPosition}/${order.directionType}/removeDriver`
    );
    return data;
  },
};
